module.exports = __webpack_public_path__ + "static/media/swc-primary-logo.ef9aab92.png";